import React, { Component } from 'react';

import '../style/subscription.css';
import { PaymentSources, paymentSourceShort } from './PaymentSources.jsx';

export default class Subscription extends Component {

  render() {
    const subscription = this.props.subscription;

    let subs;
    if (subscription === null) {
        subs = <p>Checking subscription…</p>
    } else if (!subscription) {
        subs = <p>You are not subscribed. <a href="/api/pricing">Subscribe now</a>.</p>
    } else {
        subs = <Status subscription={subscription} onSubChanged={this.props.onSubChanged} app={this.props.app} />;
    }

    return <div className="subscription">
      <h3>Subscription</h3>
      {subs}
    </div>;
  }
}

function stripeDate(date) {
    if (!date) {
        return '(no date)';
    }
    return new Date(date * 1000).toLocaleDateString(navigator.language);
}

function Status(props) {
    const sub = props.subscription;

    const infos = [];
    if (sub.status) {
        infos.push(<p key="status">Subscription status: {sub.status}.</p>);
    }
    if (sub.plan) {
        infos.push(<p key="plan">Your subscription plan is {sub.plan.name}.</p>);
    }
    if (sub.discount) {
        infos.push(<p key="discount">You have a discount applied!</p>);
    }
    if (sub.created) {
        infos.push(<p key="created">Subscribed since {stripeDate(sub.created)}.</p>);
    }
    if (sub.ended_at) {
        infos.push(<p key="ended_at"><strong>Your subscription has ended at {stripeDate(sub.ended_at)}.</strong></p>);
    }
    if (sub.current_period_start) {
        if (sub.current_period_end) {
            infos.push(<p key="current_period_start">Current billing period is {stripeDate(sub.current_period_start)} to {stripeDate(sub.current_period_end)}.</p>);
        } else {
            infos.push(<p key="current_period_start">Current billing period started on {stripeDate(sub.current_period_start)}.</p>);
        }
    }
    if (sub.trial_end && (sub.trial_end*1000) > Date.now()) {
        infos.push(<p key="trial_end">You have a free trial until {stripeDate(sub.trial_end)}.</p>);
    }
    if (sub.cancel_at_period_end) {
        infos.push(<p key="cancel_at_period_end">Your subscription will expire at the end of this period {stripeDate(sub.current_period_end)}.</p>);
    }
    if (sub.canceled_at) {
        infos.push(<p key="canceled_at">Your subscription has been cancelled at {stripeDate(sub.canceled_at)}.</p>);
    }
    infos.push(<p key="ch">To cancel or change your subscription, please <a href="mailto:kornel@imageoptim.com?subject=ImageOptim+Subscription">contact support</a>.</p>)

    infos.push(<PaymentSources key="ps" onSubChanged={props.onSubChanged} sources={sub.paymentSources} app={props.app} />);
    infos.push(invoices(sub.invoices));
    return <div>{infos}</div>;
}

function invoices(inv) {
    const invFiltered = inv && inv.filter(i => i.refunded || i.next_payment_attempt || i.total > 0);
    if (!invFiltered || !invFiltered.length) {
        return <p key="invoices">No invoices yet</p>;
    }

    return (
        <table key="invoices"><caption>Invoices</caption>
        <thead><tr><th>Date</th><th>Amount</th><th>Status</th><th>Card</th><th>Receipt</th></tr></thead>
        <tbody>
        {invFiltered.map(i => {
            return (<tr key={i.date}>
                <td>{stripeDate(i.date)}</td>
                <td>{formatAmount(i.total, i.currency)}</td>
                <td>{paymentState(i)}</td>
                <td>{chargeInfo(i.charge)}</td>
                <td>{i.charge && i.charge.receipt_number ? `#${i.charge.receipt_number}` : '-'}</td>
            </tr>);
        })}
        </tbody></table>
    );
}

function formatAmount(val, currency) {
    return (<span title={currency}>
        {currency === "usd" ? "$" : currency.toUpperCase()}
        {Math.floor(val/100)}
        {val%100 < 10 ? '.0' : '.'}
        {val%100}
    </span>);
}

function paymentState(i) {
    if (i.refunded) return "Fully refunded";

    if (i.paid) return '✔ Paid';

    if (i.attempted) {
        return <strong>Unpaid (charge failed)</strong>;
    }
    if (i.closed) {
        return <strong>Unpaid</strong>;
    }
    if (i.next_payment_attempt) {
        return <strong>Will be charged on {stripeDate(i.next_payment_attempt)}</strong>;
    }
    return <strong>Not charged yet</strong>;
}


function chargeInfo(ch) {
    if (!ch) return '';
    let src = ch.source ? paymentSourceShort(ch.source) : '';
    return `${src} ${ch.failure_message || ''}`;
}



// WEBPACK FOOTER //
// ./src/ui/Subscription.jsx